<span class="avatar">{{getUserInitials()}}</span>
